import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // For DCC, do not redirect away; the page itself renders inline login
    const path = location.pathname || '';
    if (path.startsWith('/dubaicommercity/admin')) {
      return <>{children}</>;
    }

    // Other tenants keep dedicated login pages
    const isAuditsAdminArea = path.startsWith('/audits/admin');
    const isIncorpifyAdminArea = path.startsWith('/incorpify/admin');
    const loginPath = isAuditsAdminArea
      ? '/audits/admin/access'
      : isIncorpifyAdminArea
        ? '/incorpify/admin/access'
        : '/system/access';
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
